export default {
  delete: {
    favor: '/favor',
    rating: '/rating',
    tags: '/tags',
  },
  get: {
    activity: '/activity',
    apiAgeVerificationCallback: '/age-verification-callback',
    appData: '/app-data',
    blogPost: '/blog-post/:date/:name',
    blogs: '/blogs',
    cams: '/cams',
    camUrl: '/camUrl',
    categories: '/categories',
    category: '/category',
    comments: '/comments',
    cover: '/cover',
    downloadMedia: '/download-media/:galleryUUID/:mediaType/:resolution',
    emblem: {
      getToken: '/emblem/get-token',
      getState: '/emblem/state',
    },
    favoritesAndRatings: '/favorites-ratings',
    galleries: '/galleries',
    gallery: '/gallery',
    galleryPermissions: '/gallery-permissions',
    galleryPrices: '/gallery-prices',
    image: '/image',
    invoice: '/invoice',
    itemCounts: '/item-counts',
    m3u8: {
      formats: '/m3u8/:galleryUUID.m3u8',
      film: '/m3u8/:galleryUUID/:resolution.m3u8',
    },
    markdowns: '/markdowns',
    model: '/model',
    models: '/models',
    movie: '/movie',
    movies: '/movies',
    nameLetters: '/name-letters',
    notFound: '/not-found',
    photographer: '/photographer',
    photographers: '/photographers',
    potd: '/potd',
    PPS: '/PPS',
    profile: '/get-profile',
    redirectCamModelUrl: '/cams/:model/:site*?',
    redirectCamsCategoryUrl: '/cams/category/:type',
    redirectCamsUrl: '/cams/',
    redirectOldTagsUrl: '/tags/:tag',
    searchForm: '/search-form',
    searchResults: '/search-results',
    searchSuggestions: '/search-suggestions',
    siteNotifications: '/siteNotifications',
    slideshow: '/slideshow',
    specialFeatures: '/special-features',
    splash: '/splash',
    staffSelection: '/movies/staff',
    staticSplash: '/static-splash',
    subscriptionPreview: '/subscription-preview/:token',
    tags: '/tags',
    topImages: '/top-images',
    tracking: '/tracking/:siteUUID/:type/:UUID',
    trustedPartnerSites: '/trusted-partners',
    updates: '/updates',
    upgradableSites: '/upgradable-sites',
    userData: '/user-data',
    validateDisplayName: '/validate-username/:name',
    whiteLabelSplash: '/whitelabel-splash',
  },
  post: {
    accountAvailable: '/account-available',
    analytics: '/analytics/',
    comment: '/comment',
    createUser: '/create-user',
    emblem: {
      postback: '/emblem-postback',
    },
    favor: '/favor',
    favoriteInfo: '/favorites-info',
    freeGalleryMovieActivate: '/free-galleries-movies/activate',
    lastViewedSiteNotification: '/setLastViewedSiteNotification',
    newsletterActivate: '/newsletter/activate/:token',
    optOut: '/opt-out',
    piracyReport: '/report-piracy',
    playedMovie: '/played-movie',
    playedMoviesInfo: '/played-movies-info',
    purchase: {
      gallery: '/purchase/gallery',
      upgrade: '/purchase/upgrade',
    },
    rating: '/rating',
    ratingInfo: '/ratings-info',
    reportAbuse: '/report-abuse',
    signup: {
      freeGalleriesMovies: '/signup/free-galleries-movies',
      freeTrial: '/signup/free-trial',
      newsletter: '/newsletter/subscribe',
    },
    setDisplayName: '/set-displayname',
    tags: '/tags',
  },
};

export function constructUrl(str: string) {
  return `/api${str}`;
}
